import { IH2OTheme } from '@h2oai/ui-kit';

export const filtersStyles = (theme: IH2OTheme) => ({
  borderColor: theme.palette?.gray300,
  borderRadius: 4,
  borderStyle: 'solid',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
  marginBottom: '1rem',
});
